const generateColors = (count: number) => {
  const colors = [];
  const baseHue = 220; // Starting hue (blue tone)
  const saturation = 60; // Fixed saturation for vibrancy
  const lightnessStep = 20; // Step to increase lightness in each color

  for (let i = 0; i < count; i++) {
    const hue = (baseHue + i * 30) % 360; // Adjust hue every time for variety
    const lightness = 40 + ((i * lightnessStep) % 50); // Cycle lightness between 40% and 90%
    // colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    colors.push(hslToHex(hue, saturation, lightness));
  }

  return colors;
};

function hslToHex(h: number, s: number, l: number) {
  s /= 100;
  l /= 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;

  let r = 0,
    g = 0,
    b = 0;

  if (0 <= h && h < 60) {
    r = c;
    g = x;
    b = 0;
  } else if (60 <= h && h < 120) {
    r = x;
    g = c;
    b = 0;
  } else if (120 <= h && h < 180) {
    r = 0;
    g = c;
    b = x;
  } else if (180 <= h && h < 240) {
    r = 0;
    g = x;
    b = c;
  } else if (240 <= h && h < 300) {
    r = x;
    g = 0;
    b = c;
  } else if (300 <= h && h < 360) {
    r = c;
    g = 0;
    b = x;
  }

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return `#${((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1)
    .toUpperCase()}`;
}

//   const distinctColors = generateColors(10);
//   console.log(distinctColors);
export default generateColors;
